import { render, staticRenderFns } from "./ComponentDemo.vue?vue&type=template&id=d1ed9872&"
import script from "./ComponentDemo.vue?vue&type=script&lang=js&"
export * from "./ComponentDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports